import styled from "@emotion/styled";

export const DayTimeBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  row-gap: 8px;
`;
